export enum NotificationStatus {
  Warn,
  Error,
  Success
}
